import { IDomain } from 'projects/access-control/src/app/Domain/Entities/domain.interface';

export const domains: IDomain[] = [
	{
		name: 'mango-soft.com',
	},
	{
		name: 'mango-sport.com',
	},
	{
		name: 'mango-med.com',
	},
];
